export * from './customer-fsratio-caption.component';
export * from './customer-fsratio-detail.component';